import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M 16.4 12 a 1 1 0 0 1 -0.293 0.707 l -4.8 4.8 a 1 1 0 0 1 -1.414 -1.414 L 13.986 12 L 9.893 7.907 a 1 1 0 1 1 1.414 -1.414 l 4.8 4.8 A 1 1 0 0 1 16.4 12 Z"
  />,
  'ChevronRight'
)
